<div class="d-flex flex-row justify-content-between">
  <div class="flex-wrap align-items-center">
    <h2 class="titulos ml-5">Novedades</h2>
  </div>
</div>
<hr class="ml-5 bg-naranja full-width" style="height: 2px;">
<div class="d-flex flex-wrap flex-row justify-content-center align-items-center">
  <ng-container *ngIf="totalItems>0;else noProductos">
    <app-producto-template *ngFor="let prod of productos" [producto]="prod" [logueado]="currentUser!=null"
                           [usuario]="idUsuario" [clicodigo]="clicodigo"></app-producto-template>
  </ng-container>
</div>
<div class="d-flex flex-row justify-content-center align-items-center">
  <mat-paginator [length]="totalItems" [pageSize]="cantXPagina" [pageSizeOptions]="[10, 50, 100, 200]"
                 (page)="pageEvent = getServerData($event)" showFirstLastButtons></mat-paginator>
</div>

<ng-template #noProductos>
  <div class="d-flex justify-content-center align-items-center text-info">
    No se encontraron productos.
  </div>
</ng-template>
